import { put } from 'redux-saga/effects';
import { UNREAD_MSG } from '../constants/constants';

export function* setUnreadMsgFunc(data) {
  if (data.payload.unreadMessage) {
    yield put({
      type: UNREAD_MSG,
      payload: data.payload.unreadMessage,
    });
  }
}

export function setUnread(data) {
  return {
    type: UNREAD_MSG,
    payload: data,
  };
}
